import type { TruncationResult } from '../types/highlights';
import getWords from './getWords';

export type { TruncationResult };

export function truncatePlainText(
  text: string,
  maxWords: number,
  language?: string,
): TruncationResult {
  const trimmed = text.trim();
  if (!trimmed) {
    return { text, wasTruncated: false, originalWordCount: 0, truncatedWordCount: 0 };
  }

  const words = getWords(trimmed, language ?? 'unknown');
  const originalWordCount = words.length;

  if (words.length <= maxWords) {
    return { text, wasTruncated: false, originalWordCount, truncatedWordCount: originalWordCount };
  }

  // Find the position of the Nth word's end in the original text to preserve formatting
  let wordIndex = 0;
  let charIndex = 0;

  while (wordIndex < maxWords && charIndex < trimmed.length) {
    const currentWord = words[wordIndex];
    const wordPos = trimmed.indexOf(currentWord, charIndex);
    if (wordPos === -1) {
      break;
    }
    charIndex = wordPos + currentWord.length;
    wordIndex++;
  }

  const truncated = trimmed.slice(0, charIndex).trim();
  return {
    text: truncated,
    wasTruncated: true,
    originalWordCount,
    truncatedWordCount: maxWords,
  };
}
